import brands from './brands';
import classifications from './classifications';

export default {
  brands,
  classifications
}
